function paginationInput() {
  // Bind event to nav input
  const hasPagination = document.getElementById('pagination');
  if (!hasPagination) return;

  document.addEventListener("DOMContentLoaded", () => {
      const paginationInput = document.getElementById("pagination-input");
      
      if (paginationInput) {
          paginationInput.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
              const page = parseInt(paginationInput.value, 10);
              const maxPages = parseInt(paginationInput.getAttribute("max"), 10);
              const minPages = parseInt(paginationInput.getAttribute("min"), 10);
      
              // Ensure the page number is within valid bounds
              if (page >= minPages && page <= maxPages) {
              const navPrefix = paginationInput.getAttribute("data-nav-prefix");
              window.location.href = `${navPrefix}${page}/`;
              }
          }
          });
      }
  });
}
